import React from 'react';

interface SkeletonProps extends React.HTMLAttributes<HTMLDivElement> {
  className?: string;
}

/**
 * A pulsing placeholder block. Use `className` to size + position; the
 * shared base styles handle the subtle pulse + neutral fill that matches
 * the rest of the palette. `aria-hidden` so screen readers skip the
 * placeholder rather than announcing it.
 */
const Skeleton: React.FC<SkeletonProps> = ({ className = '', ...rest }) => (
  <div
    aria-hidden="true"
    className={`animate-pulse bg-charcoal/[0.06] rounded ${className}`}
    {...rest}
  />
);

export default Skeleton;
